import { BaseServices } from 'src/app/kuba/kuba.services';
import { EmployeeServices } from './../../employees/services/employee.services';
import { Timetable } from './../../employees/models/employee';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class MyPageUserDetailResolver {
  constructor(private backend: EmployeeServices) {}
  resolve(route: ActivatedRouteSnapshot) {
    return this.backend.getUsersInfoById(BaseServices.UserId);
  }
}
